import { gql } from '@apollo/client';

export const GET_TOP_MODEL_VERSIONS = gql`
  query GetTopModelVersions($filters: DistributionGraphsInput) {
    getTopModelVersions(input: $filters) {
      amountOfListings
      label
    }
  }
`;
